export enum DialogLogTags {
  dateHeaderColumn = 'Fecha y hora',
  numberHeaderColumn = 'Número',
  typeHeaderColumn = 'Tipo',
  userHeaderColumn = 'Usuario'
}
